

/* tslint:disable */



export enum ActionType {
    Diagnostic = 0,
    Therapeutic = 1,

}


